import type React from 'react'
import { createPortal } from 'react-dom'

interface PopperPortalProps {
  children: React.ReactNode;
  portalContainer?: Element
}

export function PopperPortal ({
  children,
  portalContainer = document.body,
}: PopperPortalProps) {
  return createPortal(children, portalContainer)
}
